import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface SystemItem {
  name: string,
  icon: string,
  version: string,
}

export interface SystemGroupItem {
  groupName: string,
  systemItems: SystemItem[],
}

export interface VersionData {
  /**  windows客戶端版本 */
  windows_version: string
  /** windows server客戶端版本 */
  windows_server_version: string
  //windows xp
  windows_xp_version: string
  // windows server 2003
  windows_server2003_version: string
  /** centos amd64客戶端版本 */
  centos_amd64_version: string
  /** centos aarch64客戶端版本 */
  centos_aarch64_version: string
  /** ubuntu amd64客戶端版本 */
  ubuntu_amd64_version: string
  /** ubuntu aarch64客戶端版本 */
  ubuntu_aarch64_version: string
  /**  统信aarch64客户端版本 */
  uos_aarch64_version: string
  /**  统信amd64客户端版本 */
  uos_amd64_version: string
  /** 麒麟aarch64客户端版本 */
  kylin_aarch64_version: string
  /** 控制中心版本 */
  console_version: string
  /** 云特征库版本 */
  sample_version: string
}

@Injectable()
export class CurrentVersionService {
  constructor (private http: Http) {
  }

  getCurrentVersion () {
    return this.http.post<VersionData>('/upgrade/version', {})
  }
}
